import React from "react";

const Tomato = () => {
  return <img src={require("../BurgerAssets/tomato.svg")} alt="" />;
};

export default Tomato;
